<template>
    <div><btn>T</btn><btn>F</btn></div>
</template>

<script>
import btn from '../components/btn.vue'

export default {
  components: { btn }

}
</script>
